var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFill0Wght400Grad0Opsz241({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 64V31.4L33.6 41.8L28 36L48 16L68 36L62.4 41.8L52 31.4V64H44ZM24 80C21.8 80 19.9167 79.2167 18.35 77.65C16.7833 76.0833 16 74.2 16 72V60H24V72H72V60H80V72C80 74.2 79.2167 76.0833 77.65 77.65C76.0833 79.2167 74.2 80 72 80H24Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFill0Wght400Grad0Opsz241);
export default __webpack_public_path__ + "static/media/upload_FILL0_wght400_GRAD0_opsz24 1.616d869badd9273fe0573e1d10f755fe.svg";
export { ForwardRef as ReactComponent };